//main.js
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
//引入语言包
import LangEn from '../static/lang/en'
import LangZh from '../static/lang/zh'
import LangTc from '../static/lang/tc' 
Vue.use(VueI18n)
//引入vue-layer
import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);
import 'babel-polyfill'
//全局变量
import global_ from './components/common/global.js';
Vue.use(global_);
// axios
import axios from 'axios'
Vue.prototype.$http = axios
// 默认中文
if(localStorage.language == undefined){
	localStorage.language = 'zh';
}
// 跳转到英文页面 方法
var url = location.search;	 // 获取url中"?"符后的字串 ('?modFlag=business&role=1')
if(url.indexOf("?") != -1) {
 	let str = url.split("?")[1];
 	let strs = str.split("&");
 	for (var i = 0; i < strs.length; i++) {
    localStorage.setItem(strs[i].split("=")[0], strs[i].split("=")[1]);
    location.search = "";
 	}
}

// VHouse页面,如果地址有en,则跳转到英文页面
//if(window.location.href.search(/lg=en/i) != -1){
//	localStorage.language = 'en';
//}else{
//	localStorage.language = 'zh';
//}
const i18n = new VueI18n({
  locale: localStorage.language,  // 语言标识
  messages: {
    'zh': LangZh,
    'en': LangEn,
    'tc': LangTc
  }
})
Vue.config.productionTip = false
//跳转路由后回到顶部
router.afterEach((to,from,next) => {
	window.scrollTo(0,0);
	
	//	除'联系我们'底部有项目合作外 其它页面均不显示
	if(to.path == '/lianxi'){
		$('.lianxiFoot').removeClass('hidden-sm hidden-xs')
	}else{
		$('.lianxiFoot').addClass('hidden-sm hidden-xs')
	}
})
/*
// 加入百度统计代码
router.beforeEach((to, from, next) => {
	if (to.path) {
	  _hmt.push(['_trackPageview', '/#' + to.fullPath]);
	}
	next();
})
/* eslint-disable no-new */


new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js